import logger from 'src/utils/logger';

const key = 'malzemeler'

export const saveMalzeme = (kulModelKodu, garantitipi, data) => {
    try {
        removeMalzeme(kulModelKodu);
        const malzemeObj = {
            KUL_MODEL_KODU: kulModelKodu,
            GARANTI_TIPI: garantitipi,
            DATE: new Date(),
            DATA: data,
        }
        let malzemeler = loadMalzemeler();
        malzemeler = [...malzemeler, malzemeObj];
        localStorage.removeItem(key);
        localStorage.setItem(key, JSON.stringify(malzemeler));
    } catch (error) {
        logger.error("Storage limit exceeded Malzeme");
        localStorage.removeItem(key);
    }
};

// Modele ait malzemeleri kontrol eder. Tarih aynı gün değilse siler ve boş döner. Değilse, malzeme datasını döner.
export const loadMalzeme = (kulModelKodu, garantiTipi) => {
    try {
        let malzemeler = loadMalzemeler();
        let filtered = malzemeler.filter(h => h.KUL_MODEL_KODU === kulModelKodu && h.GARANTI_TIPI === garantiTipi);
        if (filtered.length === 0) { // localde yok. Return empty.
            return [];
        }
        if (filtered.length > 1) { // aynı modele ait birden fazla malzeme verisi olamaz. Something is wrong!. Clear locale data and return empty.
            removeMalzeme(kulModelKodu);
            return [];
        }
        const malzeme = filtered[0];
        const now = new Date();
        const ld = new Date(malzeme.DATE); // Last Date
        if (now.getYear() === ld.getYear() && now.getMonth() === ld.getMonth() && now.getDate() === ld.getDate()) {
            return malzeme.DATA;
        }
        removeMalzeme(kulModelKodu);
        return [];
    } catch (error) {
        return [];
    }
};


export const checkMalzeme = (kulModelKodu) => {
    try {
        let malzemeler = loadMalzemeler();
        let filtered = malzemeler.filter(h => h.KUL_MODEL_KODU === kulModelKodu);
        return filtered.length === 0 ? false : true;
    } catch (error) {
        return false;
    }
};


///////////// HELPER METHODS (NOT EXPORTED) /////////////////////

// localstorage'daki tüm malzemeleri getirir.
const loadMalzemeler = () => {
    try {
        let malzemelerTxt = localStorage.getItem(key);
        if (!malzemelerTxt) {
            localStorage.setItem(key, "[]");
            malzemelerTxt = "[]";
        }
        return JSON.parse(malzemelerTxt);
    } catch (error) {
        return [];
    }
}


// Modele ait tüm malzemeler local storage'dan silinir.
const removeMalzeme = (kulModelKodu) => {
    try {
        const malzemeler = loadMalzemeler();
        const otherMalzemeler = malzemeler.filter(h => h.KUL_MODEL_KODU !== kulModelKodu);
        localStorage.setItem(key, JSON.stringify(otherMalzemeler));
        return true;
    } catch (error) {
        return false;
    }
};